// Lightweight helpers for accessing the current authenticated session
// stored in localStorage ("user").

export function getStoredUser() {
  try {
    const text = localStorage.getItem("user");
    if (!text) return null;
    return JSON.parse(text);
  } catch {
    return null;
  }
}

export function getUserId() {
  const u = getStoredUser();
  return (
    u?.userID ||
    u?.UserID ||
    u?.userid ||
    u?.userId ||
    ""
  ).toString();
}

export function getAccessToken() {
  const u = getStoredUser();
  return (u?.accessToken || u?.AccessToken || "").toString().trim();
}
